import React, {Component} from 'react';
import { Form, Input, AddButton } from '../styles/search_bar_styles';


class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = props.data;//array concat in action
    this.apiCall = props.apiCall
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(event) {
    event.preventDefault();
    let existing = this.state.query_terms;
    const searchTerm = event.target.query.value;
    if(searchTerm !== "") {
      let newTerms = existing.concat(searchTerm);
      event.target.query.value = "";
      this.apiCall(newTerms);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(
      props.data
    );
  }

  render() {
    const selection = this.state.nav_selection
    const placeholder = `search for ${selection}`

    return (
      <Form onSubmit={this.onFormSubmit}>
        <Input placeholder= {placeholder}
          name="query"
        />
        <AddButton type="submit"> Add </AddButton>
      </Form>
    );
  }

}

export default SearchBar;
